module.exports = __webpack_public_path__ + "img/csn.5d5dd62c.jpg";